export enum TrackBuyProvider {
  Apple = 'Apple',
  Beatport = 'Beatport',
  DjCity = 'DjCity',
}

export enum TrackVendor {
  Apple,
  Beatport,
  Spotify,
  DjCity,
}

export interface Track {
  artist: string;
  title: string;
  collection: string;
  titleSimplified?: string;
  duration?: number;
  price?: number;
  vendor?: TrackVendor;
  vendorUrl?: string;
  vendorCollectionUrl?: string;
  vendorArtistUrl?: string;
  previewUrl?: string;
  artworkUrl?: string;
  fileUrl?: string;
}
